import { Moon, Sun } from "lucide-react";
import type { Theme } from "../core/theme";

/**
 * Flips between light and dark, following the OS until the user picks the
 * other theme (ADR-0027). The icon shows the theme a click switches to.
 */
export function ThemeToggle({ theme, onToggle }: { theme: Theme; onToggle: () => void }) {
  const target = theme === "dark" ? "light" : "dark";
  const Icon = target === "dark" ? Moon : Sun;
  return (
    <button
      type="button"
      onClick={onToggle}
      title={`Switch to ${target} theme`}
      aria-label={`Switch to ${target} theme`}
      data-testid="theme-toggle"
      className="rounded p-1.5 text-fg-dark hover:bg-bg-highlight hover:text-fg focus-visible:outline-2 focus-visible:outline-blue"
    >
      <Icon size={16} aria-hidden />
    </button>
  );
}
